import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

// Plain-text length is what "200ch" means to a reader — HTML tags don't count.
const stripHtml = (html) => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

// Collapsed state shows a plain-text preview (safe to cut mid-string).
// Expanded state renders the full HTML so formatting isn't lost.
const ReadMoreHtml = ({ html, maxChars = 200, className = "" }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const plainText = useMemo(() => stripHtml(html), [html]);
  const isTruncated = plainText.length > maxChars;
  const preview = isTruncated
    ? `${plainText.slice(0, maxChars).trimEnd()}…`
    : plainText;

  if (!html) return null;

  const toggle = () => setExpanded((prev) => !prev);

  return (
    <div className={className}>
      {expanded ? (
        <>
          <div dangerouslySetInnerHTML={{ __html: html }} />
          {isTruncated && (
            <button
              type="button"
              onClick={toggle}
              className="mt-1 font-medium text-primary hover:underline"
              style={{ fontSize: "inherit" }}
            >
              {t("general.read_less", "Read less")}
            </button>
          )}
        </>
      ) : (
        <p>
          {preview}
          {isTruncated && (
            <>
              {" "}
              <button
                type="button"
                onClick={toggle}
                className="font-medium text-primary hover:underline whitespace-nowrap"
                style={{ fontSize: "inherit" }}
              >
                {t("general.read_more", "Read more")}
              </button>
            </>
          )}
        </p>
      )}
    </div>
  );
};

export default ReadMoreHtml;
